;(function (module) {
  'use strict'
  module.controller('phoneHistoryController', [
    '$scope',
    'progressBar',
    'ngDialog',
    'historyPhone',
    'members',
    '$filter',
    'tripsDashBoard',
    'commonDialogMessage',
    'toastr',
    'currency',
    'uiGridConstants',
    'clientSelectService',
    'agencySelectService',
    'toastFactory',
    'authService',
    '$timeout',
    function (
      $scope,
      progressBar,
      ngDialog,
      historyPhone,
      members,
      $filter,
      tripsDashBoard,
      commonDialogMessage,
      toastr,
      currency,
      uiGridConstants,
      clientSelectService,
      agencySelectService,
      toastFactory,
      authService,
      $timeout,
    ) {
      let progress = progressBar.getProgressBar()
      let gridData = []
      $scope.dateFrom = new Date()
      $scope.dateTo = addMonth($scope.dateFrom)
      let memberId = null
      let memberIds = []
      let priorityData = ['Low', 'Medium', 'High', 'Critical']

      function addMonth(startDate) {
        // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
        return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1))
      }
      // Validate that filtered organization id is defined
      function validateOrganization() {
        const organization = clientSelectService.getSelectedClient()
        return organization.id != null && Number.isInteger(organization.id)
      }
      //to set travelerName autoSearch data
      function getTravelers() {
        $scope.dataSource = []
        if (authService.getLoginMember().Role === 3) {
          members.getMembers().then(function (response) {
            let memberInfo = response.data
            $scope.dataSource = memberInfo.map(function (member) {
              return {
                name: member.FirstName + '' + member.LastName,
                id: member.Id,
              }
            })
            memberIds = _.map($scope.dataSource, 'id')
          })
        } else {
          const valid = validateAgencyAndClientSelection()
          if (valid.agencyValid && valid.clientValid) {
            let organization = clientSelectService.getSelectedClient()
            members
              .getMembersByOrgId(organization.id)
              .then(function (response) {
                let memberInfo = response.data
                $scope.dataSource = memberInfo.map(function (member) {
                  return {
                    name: member.FirstName + '' + member.LastName,
                    id: member.Id,
                  }
                })
                memberIds = _.map($scope.dataSource, 'id')
              })
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
        }
      }
      getTravelers()

      function getFlightContext(bookingId) {
        tripsDashBoard.getFlightsDashById(bookingId).then(
          function (flights) {
            let contextData = flights.data
            let statusColor = '#000000' //black
            let flightStatus = 'scheduled'
            let dateTime = new Date()
            let arrivalTime = moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss')
            if (contextData.FlightStat !== null) {
              let departureTime = moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              )
              let estimatedDeparuteTime = moment(
                contextData.FlightStat.EstimatedDeparture,
              ).format('MM-DD-YYYY h:mm:ss')
              let estimatedArrival = moment(
                contextData.FlightStat.EstimatedArrival,
              ).format('MM-DD-YYYY h:mm:ss')
              statusColor =
                departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                  ? '#3d9400'
                  : estimatedDeparuteTime > departureTime
                  ? '#cc0000'
                  : statusColor
              flightStatus =
                departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                  ? 'on time'
                  : estimatedDeparuteTime > departureTime
                  ? 'delayed'
                  : currentDateTime > estimatedArrival
                  ? 'past flight'
                  : flightStatus
            }
            if (contextData.Cancelled === true) {
              statusColor = '#cc0000' //red
              flightStatus = 'cancelled'
            }
            if (
              contextData.FlightStat === null &&
              currentDateTime > arrivalTime
            ) {
              flightStatus = 'past flight'
            }
            $scope.flightContext = {
              statusColor: statusColor,
              flightStatus: flightStatus,
              estimatedDeparture:
                contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedDeparture !== null
                  ? contextData.FlightStat.EstimatedDeparture
                  : contextData.DepartureDateTime,
              estimatedArrival:
                contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedArrival !== null
                  ? contextData.FlightStat.EstimatedArrival
                  : contextData.ArrivalDateTime,
              pnr: contextData.Pnr,
              depart:
                contextData.DepartureName +
                ' (' +
                contextData.DepartureAirport +
                ')',
              arrival:
                contextData.ArrivalName +
                ' (' +
                contextData.ArrivalAirport +
                ')',
              departureName: contextData.DepartureName,
              departureAirport: contextData.DepartureAirport,
              departureDateTime: moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              departureGate:
                contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureGate !== null
                  ? contextData.FlightStat.DepartureGate
                  : '-',
              departureTerminal:
                contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureTerminal !== null
                  ? contextData.FlightStat.DepartureTerminal
                  : '-',
              startDate: contextData.DepartureDateTime,
              endDate: contextData.ArrivalDateTime,
              arrivalName: contextData.ArrivalName,
              arrivalAirport: contextData.ArrivalAirport,
              arrivalDateTime: moment(contextData.ArrivalDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              arrivalGate:
                contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalGate !== null
                  ? contextData.FlightStat.ArrivalGate
                  : '-',
              arrivalTerminal:
                contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalTerminal !== null
                  ? contextData.FlightStat.ArrivalTerminal
                  : '-',
              operatingAirline: contextData.OperatingAirline,
              flightNumber: contextData.FlightNumber,
              duration: contextData.Duration,
              bookingSource: contextData.BookingSource,
              confirmation: contextData.ConfirmationNumber,
              cabin: contextData.Cabin,
              bookingClass: contextData.BookingClass,
              numberInParty: contextData.NumberInParty,
              airTravelers: contextData.AirReservation.AirTravelers,
              comment: contextData.AirReservation.Comment,
              seats: contextData.Seats,
              totalCharge:
                currency.getCurrencySymbol(
                  contextData.AirReservation.CurrencyCode,
                ) + contextData.AirReservation.TotalFare,
              lastUpdated: moment(contextData.Updated).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              isDeleted: contextData.Deleted ? 'Yes' : 'No',
              vendor: contextData.Vendor,
            }
          },
          function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`
                    $scope.errTitle = 'Phone History Error'
                  },
                ],
              })
            }
          },
        )
      }

      function getHotelContext(bookingId) {
        tripsDashBoard.getHotelsDashById(bookingId).then(function (hotels) {
          let contextData = hotels.data
          ;($scope.hotelContext = {
            pnr: contextData.Pnr,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              currency.getCurrencySymbol(
                contextData.CurrencyCode === null
                  ? ''
                  : contextData.CurrencyCode,
              ) + contextData.Total,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
          }),
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'dlg-template-phoneHistory',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.phoneHistoryError = err.statusText
                      $scope.additionalInfo = '' //PLACE HOLDER
                      $scope.messageTitle = 'Phone History Error'
                    },
                  ],
                })
              }
            }
        })
      }

      function getCarContext(bookingId) {
        tripsDashBoard.getCarsDashById(bookingId).then(function (cars) {
          let contextData = cars.data
          ;($scope.carContext = {
            pnr: contextData.Pnr,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              currency.getCurrencySymbol(contextData.CurrencyCode) +
              contextData.TotalCharge,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
          }),
            function (err) {
              ngDialog.open({
                template: 'dlg-template-phoneHistory',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.phoneHistoryError = err.statusText
                    $scope.additionalInfo = '' //PLACE HOLDER
                    $scope.messageTitle = 'Phone History Error'
                  },
                ],
              })
            }
        })
      }
      // ui-grid code
      const paginationOptions = {
        pageNumber: 1,
        pageSize: 25,
        sort: null,
      }
      $scope.gridOptions = {
        paginationPageSizes: [5, 10, 25, 50],
        enableFiltering: true,
        enableGridMenu: true,
        paginationPageSize: 25,
        useExternalPagination: true,
        useExternalSorting: false,
        enableRowSelection: true,
        enableSelectAll: false,
        enableRowHeaderSelection: false,
        multiSelect: false,
        enableColumnResizing: true,
        columnDefs: [
          {
            name: 'Member.DisplayName',
            displayName: 'Traveler',
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          },
          {
            name: 'Member.Organization.Name',
            displayName: 'Company',
            visible: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'FromPhoneNumber',
            displayName: 'Traveler Number',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'TimeOfCall',
            displayName: 'Incoming',
            visible: true,
            enableHiding: true,
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{grid.appScope.getLocalTimeZone(row.entity.TimeOfCall)}}</div>',
            maxWidth: 250,
            enableColumnResizing: true,
            maxWidth: 250,
          },
          {
            name: 'TimeTurnedOverToAgentSystem',
            displayName: 'Received',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            cellClass: 'grid-align',
            cellFilter: "date:'MM-dd-yyyy h:mm a'",
            maxWidth: 250,
            enableColumnResizing: true,
          },
          {
            name: 'Success',
            displayName: 'Success',
            visible: false,
            enableSorting: false,
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate:
              ' <span ng-show="row.entity.Success" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Success" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [
                {
                  value: 'true',
                  label: 'Yes',
                },
                {
                  value: 'false',
                  label: 'No',
                },
              ],
            },
          },
          {
            name: 'PriorityName',
            displayName: 'Priority',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            cellClass: 'grid-align',
            maxWidth: 250,
            enableColumnResizing: true,
          },
        ],
        onRegisterApi: function (gridApi) {
          $scope.gridApi = gridApi
          $scope.gridApi.core.on.sortChanged($scope, function (
            grid,
            sortColumns,
          ) {
            if (!sortColumns.length) {
              paginationOptions.sort = null
            } else {
              paginationOptions.sort = sortColumns[0].sort.direction
            }
            updateGridPagination(gridData)
          })
          gridApi.pagination.on.paginationChanged($scope, function (
            newPage,
            pageSize,
          ) {
            paginationOptions.pageNumber = newPage
            paginationOptions.pageSize = pageSize
            updateGridPagination(gridData)
          })
          // Show trip booking details on grid row selection.
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            $scope.TripContext = false
            if (!!row.entity.CarId) {
              $scope.bookingType = 'Car Reservation'
              getCarContext(row.entity.CarId) //show booking details for Car
              getCarDetails(row.entity.CarId, row.entity.Member.DisplayName) //Get details for car
            } else if (!!row.entity.FlightId) {
              $scope.bookingType = 'Airline Reservation'
              getFlightContext(row.entity.FlightId) //show booking details for Flight
              getFlightDetails(
                row.entity.FlightId,
                row.entity.Member.DisplayName,
              ) //Get details for flight
            } else if (!!row.entity.HotelId) {
              $scope.bookingType = 'Hotel Reservation'
              getHotelContext(row.entity.HotelId) //show booking details for Hotel
              getHotelDetails(row.entity.HotelId, row.entity.Member.DisplayName) //Get details for hotel
            }
            if (!!row.entity.TripId) {
              $scope.TripContext = true
              $scope.contextList = []
              let tripFlightContext = []
              let tripCarContext = []
              let tripHotelContext = []
              tripsDashBoard
                .getTripsDashbyId(row.entity.TripId)
                .then(function (trips) {
                  tripFlightContext = trips.data.Flights
                  tripCarContext = trips.data.Cars
                  tripHotelContext = trips.data.Hotels
                  let flightList = []
                  let hotelList = []
                  let carList = []
                  if (!!tripFlightContext.length) {
                    flightList = generateFlightContext(tripFlightContext)
                  }
                  if (!!tripCarContext.length) {
                    carList = generateCarContext(tripCarContext)
                  }
                  if (!!tripHotelContext.length) {
                    hotelList = generateHotelContext(tripHotelContext)
                  }
                  $scope.contextList = [flightList, carList, hotelList].reduce(
                    function (prevData, currData) {
                      return prevData.concat(currData)
                    },
                    [],
                  )
                  let sortByDateAsc = function (a, b) {
                    let firstStartDate = moment(a.startDate).format(
                      'MM-DD-YYYY',
                    )
                    let secondStartDate = moment(b.startDate).format(
                      'MM-DD-YYYY',
                    )
                    if (firstStartDate > secondStartDate) {
                      return 1
                    } else if (firstStartDate < secondStartDate) {
                      return -1
                    } else if (firstStartDate === secondStartDate) {
                      if (a.bookingTypeName === 'A') {
                        return -1
                      } else if (b.bookingTypeName === 'A') {
                        return 1
                      } else if (
                        a.bookingTypeName === 'H' &&
                        b.bookingTypeName === 'C'
                      ) {
                        return -1
                      } else if (
                        a.bookingTypeName === 'C' &&
                        b.bookingTypeName === 'H'
                      ) {
                        return 1
                      } else {
                        return 0
                      }
                    }
                  }
                  $scope.contextList.sort(sortByDateAsc)
                })
            }
          })
        },
      }
      //function to set ui-grid data
      function setGridData() {
        // Clear grid
        getTravelers()
        $scope.tripsList = []
        $scope.gridOptions.data = []
        $scope.gridOptions.totalItems = 0
        updateGridPagination(gridData)
      }

      function updateGridPagination(gridData) {
        let firstRow =
          (paginationOptions.pageNumber - 1) * paginationOptions.pageSize
        $scope.gridOptions.data = gridData.slice(
          firstRow,
          firstRow + paginationOptions.pageSize,
        )
        $scope.gridOptions.totalItems = gridData.length
        for (var i = 0; i < gridData.length; i++) {
          gridData[i].PriorityName = priorityData[gridData[i].Priority]
          gridData[i].Member.DisplayName =
            gridData[i].Member.LastName + '/' + gridData[i].Member.FirstName
        }
      }
      $scope.getLocalTimeZone = function (dateTime) {
        let fullDate = new Date(dateTime)
        let date = fullDate.getDate()
        if (date < 10) {
          date = '0' + date
        }
        let month = fullDate.getMonth() + 1
        if (month < 10) {
          month = '0' + month
        }
        let year = fullDate.getFullYear()
        let hour = fullDate.getHours()
        if (hour < 10) {
          hour = '0' + hour
        }
        let minute = fullDate.getMinutes()
        if (minute < 10) {
          minute = '0' + minute
        }
        let second = fullDate.getSeconds()
        if (second < 10) {
          second = '0' + second
        }
        fullDate =
          year +
          '-' +
          month +
          '-' +
          date +
          'T' +
          hour +
          ':' +
          minute +
          ':' +
          second +
          '.000Z'
        let currentTime = new Date(fullDate)
        return moment(currentTime).format('MM-DD-YYYY h:mm:ss a')
      }
      //for getting search by from Date, to Date and travelerName
      $scope.searchPhoneHistory = function () {
        gridData = []
        $scope.closeDetails()
        $scope.isInDetails = true
        memberId =
          $scope.client != null && $scope.client.name.length === 0
            ? null
            : $scope.selectedValue
        if (validateOrganization()) {
          if (!!$scope.dateFrom && !!$scope.dateTo && !!memberId) {
            progress.start()
            historyPhone
              .getPhoneLogsForMember(
                memberId,
                $filter('date')($scope.dateFrom, 'MM-dd-yyyy'),
                $filter('date')($scope.dateTo, 'MM-dd-yyyy'),
              )
              .then(
                function (phoneLogsForMember) {
                  gridData = phoneLogsForMember.data
                  if (gridData.length < 1) {
                    //\\toastr.warning(commonDialogMessage.phoneHistoryNoResultMessage);
                  }
                },
                function (err) {
                  ngDialog.open({
                    template: 'dlg-template-phoneHistory',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.phoneHistoryError = err.statusText
                        $scope.additionalInfo = '' //PLACE HOLDER
                        $scope.messageTitle = 'Phone History Error'
                      },
                    ],
                  })
                },
              )
              .finally(function () {
                progress.complete()
                setGridData()
              })
          } else if (!!$scope.dateFrom && !!$scope.dateTo) {
            progress.start()
            historyPhone
              .getPhoneLogsForAllMember(
                $filter('date')($scope.dateFrom, 'MM-dd-yyyy'),
                $filter('date')($scope.dateTo, 'MM-dd-yyyy'),
              )
              .then(
                function (phoneLogsForAllMember) {
                  let allMemberData = phoneLogsForAllMember.data
                  gridData = allMemberData.filter(function (memberData) {
                    return memberIds.indexOf(memberData.MemberId) >= 0
                  })
                  if (gridData.length < 1) {
                    //\\toastr.warning(commonDialogMessage.phoneHistoryNoResultMessage);
                  }
                },
                function (err) {
                  ngDialog.open({
                    template: 'dlg-template-phoneHistory',
                    className: 'ngdialog-theme-plain',
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.phoneHistoryError = err.statusText
                        $scope.additionalInfo = '' //PLACE HOLDER
                        $scope.messageTitle = 'Phone History Error'
                      },
                    ],
                  })
                },
              )
              .finally(function () {
                progress.complete()
                setGridData()
              })
          }
        } else {
          // toastr.warning('Please select a client.', 'Alert', {
          // closeButton: true,
          // timeOut: 3500,
          // });
        }
      }
      if (!!$scope.dateFrom && !!$scope.dateTo) {
        progress.start()
        historyPhone
          .getPhoneLogsForAllMember(
            $filter('date')($scope.dateFrom, 'MM-dd-yyyy'),
            $filter('date')($scope.dateTo, 'MM-dd-yyyy'),
          )
          .then(
            function (phoneLogsForAllMember) {
              let allMemberData = phoneLogsForAllMember.data
              gridData = allMemberData.filter(function (memberData) {
                return memberIds.indexOf(memberData.MemberId) >= 0
              })
              if (gridData.length < 1) {
                //\\toastr.warning(commonDialogMessage.phoneHistoryNoResultMessage);
              }
            },
            function (err) {
              ngDialog.open({
                template: 'dlg-template-phoneHistory',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.phoneHistoryError = err.statusText
                    $scope.additionalInfo = '' //PLACE HOLDER
                    $scope.messageTitle = 'Phone History Error'
                  },
                ],
              })
            },
          )
          .finally(function () {
            progress.complete()
            setGridData()
          })
      }

      function getFlightDetails(flightId, travelerName) {
        progress.start()
        historyPhone
          .getPhoneLogDetailsForFlight(flightId)
          .then(function (response) {
            if (!!response) {
              $scope.isInDetails = true
            } else {
              $scope.isInDetails = false
            }
          })
          .finally(function () {
            progress.complete()
          })
      }

      function getCarDetails(carId, travelerName) {
        progress.start()
        historyPhone
          .getPhoneLogDetailsForCar(carId)
          .then(function (response) {
            if (!!response) {
              $scope.isInDetails = true
            } else {
              $scope.isInDetails = false
            }
          })
          .finally(function () {
            progress.complete()
          })
      }

      function getHotelDetails(hotelId, travelerName) {
        progress.start()
        historyPhone
          .getPhoneLogDetailsForHotel(hotelId)
          .then(function (response) {
            if (!!response) {
              $scope.isInDetails = true
              let details = response.data
            } else {
              $scope.isInDetails = false
            }
          })
          .finally(function () {
            progress.complete()
          })
      }
      $scope.closeDetails = function () {
        $scope.isInDetails = false
        $scope.bookingType = null
        $scope.TripContext = false
      }
      // Validate that filtered organization id is defined
      function validateAgencyAndClientSelection() {
        const agency = agencySelectService.getSelectedAgency()
        const client = clientSelectService.getSelectedClient()
        return {
          agencyValid: agency.id != null && Number.isInteger(agency.id),
          clientValid: client.id != null && Number.isInteger(client.id),
        }
      }

      function generateFlightContext(flightContext) {
        return flightContext.map(function (contextData) {
          let statusColor = '#000000' //black
          let flightStatus = 'scheduled'
          let currentDateTime = new Date()
          let arrivalTime = moment(contextData.ArrivalDateTime).format(
            'MM-DD-YYYY h:mm:ss',
          )
          currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss')
          if (contextData.FlightStat !== null) {
            let departureTime = moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let estimatedDeparuteTime = moment(
              contextData.FlightStat.EstimatedDeparture,
            ).format('MM-DD-YYYY h:mm:ss')
            let estimatedArrival = moment(
              contextData.FlightStat.EstimatedArrival,
            ).format('MM-DD-YYYY h:mm:ss')
            statusColor =
              departureTime === estimatedDeparuteTime ||
              estimatedDeparuteTime < departureTime
                ? '#3d9400'
                : estimatedDeparuteTime > departureTime
                ? '#cc0000'
                : statusColor
            flightStatus =
              departureTime === estimatedDeparuteTime ||
              estimatedDeparuteTime < departureTime
                ? 'on time'
                : estimatedDeparuteTime > departureTime
                ? 'delayed'
                : currentDateTime > estimatedArrival
                ? 'past flight'
                : flightStatus
          }
          if (contextData.Cancelled === true) {
            statusColor = '#cc0000' //red
            flightStatus = 'cancelled'
          }
          if (
            contextData.FlightStat === null &&
            currentDateTime > arrivalTime
          ) {
            flightStatus = 'past flight'
          }
          return {
            statusColor: statusColor,
            flightStatus: flightStatus,
            estimatedDeparture:
              contextData.FlightStat !== null &&
              contextData.FlightStat.EstimatedDeparture !== null
                ? contextData.FlightStat.EstimatedDeparture
                : contextData.DepartureDateTime,
            estimatedArrival:
              contextData.FlightStat !== null &&
              contextData.FlightStat.EstimatedArrival !== null
                ? contextData.FlightStat.EstimatedArrival
                : contextData.ArrivalDateTime,
            pnr: contextData.Pnr,
            bookingTypeName: 'A',
            bookingType: 'Airline Reservation',
            depart:
              contextData.DepartureName +
              ' (' +
              contextData.DepartureAirport +
              ')',
            arrival:
              contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
            departureName: contextData.DepartureName,
            departureAirport: contextData.DepartureAirport,
            departureDateTime: moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            departureGate:
              contextData.FlightStat !== null &&
              contextData.FlightStat.DepartureGate !== null
                ? contextData.FlightStat.DepartureGate
                : '-',
            departureTerminal:
              contextData.FlightStat !== null &&
              contextData.FlightStat.DepartureTerminal !== null
                ? contextData.FlightStat.DepartureTerminal
                : '-',
            startDate: contextData.DepartureDateTime,
            endDate: contextData.ArrivalDateTime,
            arrivalName: contextData.ArrivalName,
            arrivalAirport: contextData.ArrivalAirport,
            arrivalDateTime: moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            arrivalGate:
              contextData.FlightStat !== null &&
              contextData.FlightStat.ArrivalGate !== null
                ? contextData.FlightStat.ArrivalGate
                : '-',
            arrivalTerminal:
              contextData.FlightStat !== null &&
              contextData.FlightStat.ArrivalTerminal !== null
                ? contextData.FlightStat.ArrivalTerminal
                : '-',
            operatingAirline: contextData.OperatingAirline,
            flightNumber: contextData.FlightNumber,
            duration: contextData.Duration,
            bookingSource: contextData.BookingSource,
            confirmation: contextData.ConfirmationNumber,
            cabin: contextData.Cabin,
            bookingClass: contextData.BookingClass,
            numberInParty: contextData.NumberInParty,
            airTravelers: contextData.AirReservation.AirTravelers,
            comment: contextData.AirReservation.Comment,
            seats: contextData.Seats,
            totalCharge:
              currency.getCurrencySymbol(
                contextData.AirReservation.CurrencyCode,
              ) + contextData.AirReservation.TotalFare,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
            vendor: contextData.Vendor,
          }
        })
      }

      function generateCarContext(carContext) {
        return carContext.map(function (contextData) {
          return {
            pnr: contextData.Pnr,
            bookingTypeName: 'C',
            bookingType: 'Car Reservation',
            startDate: contextData.PickUpDateTime,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              currency.getCurrencySymbol(contextData.CurrencyCode) +
              contextData.TotalCharge,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
          }
        })
      }

      function generateHotelContext(hotelContext) {
        return hotelContext.map(function (contextData) {
          return {
            pnr: contextData.Pnr,
            bookingTypeName: 'H',
            bookingType: 'Hotel Reservation',
            startDate: contextData.CheckInDate,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              currency.getCurrencySymbol(contextData.CurrencyCode) +
              contextData.Total,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
          }
        })
      }
      // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
      $scope.$watch(
        function () {
          return clientSelectService.getSelectedClient()
        },
        function (newValue, oldValue) {
          $scope.dataSource = []
          $scope.tripsList = []
          $scope.gridOptions.data = []
          $scope.gridOptions.totalItems = 0
          $scope.isInDetails = false
          $scope.bookingType = null
          if (newValue !== oldValue) {
            $scope.client = null
            $scope.selectedValue = null
            memberIds = []
            getTravelers()
            $timeout($scope.searchPhoneHistory, 3000)
          }
        },
        true,
      )
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/phoneHistoryController.js